import { combineSlices, configureStore, Tuple } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { routeSlice } from 'slices/routes';
import { banksSlice } from 'slices/banks';
import { errorSlice } from 'slices/errors';
import { modalSlice } from 'slices/modal';
import { productOnboardingSlice } from 'slices/productOnboarding';
import { uiThemeSlice } from 'slices/uiTheme';
import { accountTypeSlice } from 'slices/accountType';
import { drawerMenuSlice } from 'slices/drawerMenu';
import { mandateSlice } from 'slices/mandates';
import { signatureSlice } from 'slices/signature';

import { sagas } from 'sagas';
import { api } from 'api/reducer';
import { app } from 'reducers/app';
import { paymentPartner } from 'reducers/paymentPartner';
import { transferAmount } from 'reducers/transferAmount';
import { locale } from 'locale/reducer';
import { idCard } from 'reducers/idCard';

const sagaMiddleware = createSagaMiddleware();

export const storeDefinition = {
  reducer: combineSlices(
    banksSlice,
    routeSlice,
    errorSlice,
    modalSlice,
    uiThemeSlice,
    accountTypeSlice,
    drawerMenuSlice,
    mandateSlice,
    signatureSlice,
    productOnboardingSlice,
    {
      api,
      app,
      paymentPartner,
      transferAmount,
      locale,
      idCard
    }
  )
};

export const store = configureStore({
  ...storeDefinition,
  middleware: () => new Tuple(sagaMiddleware)
});

sagaMiddleware.run(sagas);

export type RootState = ReturnType<typeof store.getState>;
export type RootDispatch = ReturnType<typeof store.dispatch>;
